import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { IncludeProductsState } from "@thkStore/Store/Widgets/IncludeProducts/IncludeProductsState";
import { Draft } from "immer";

const initialState: IncludeProductsState = {
    productId: "",
    checked: false,
};

const reducer = {
    "Widgets/IncludeProducts/SetChecked": (
        draft: Draft<IncludeProductsState>,
        action: {
            parameter: {
                productId: string;
                checked: boolean;
            };
        },
    ) => {
        draft.productId = action.parameter.productId;
        draft.checked = action.parameter.checked;
    },
};

const includeProductsReducer = createTypedReducerWithImmer(initialState, reducer);

(reducers as any).includeProducts = includeProductsReducer;

export type ApplicationIncludeProductsState = {
    includeProducts: IncludeProductsState;
} & ApplicationState;

type Reducers = {
    includeProducts: typeof includeProductsReducer;
};

export type IncludeProductsActions = Parameters<Reducers[keyof Reducers]>[1] | AnyAction;
